module.exports = __webpack_public_path__ + "static/media/01.fe1fb15f.jpg";